import { useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/bg-reset-cover.jpeg";

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

function SetNewPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSetPassword = async () => {
    try {
      await axios.post(`${BACKEND_BASE_URL}/api/v1/auth/reset-password`, null, {
        params: { token, new_password: password },
      });
      setMessage("Password reset successful. Redirecting to login...");
      
      setTimeout(() => {
        navigate("/authentication/sign-in");
      }, 2000); // wait 2 seconds before redirect
    } catch (err) {
      setMessage("Invalid or expired token.");
    }
  };

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox textAlign="center" mt={2}>
          <MDTypography variant="h4">Set New Password</MDTypography>
        </MDBox>
        <MDBox p={3}>
          <MDInput
            label="New Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <MDBox mt={3}>
            <MDButton variant="gradient" color="info" fullWidth onClick={handleSetPassword}>
              Submit
            </MDButton>
          </MDBox>
          {message && (
            <MDTypography mt={2} color="text" textAlign="center">
              {message}
            </MDTypography>
          )}
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default SetNewPassword;
